import React, { useMemo } from "react";
import "./Disclaimer.css";
import { useLocalContext } from "../../context/LocalContext";

const Disclaimer = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "Your Brand",
      email: webinfo.email || "hello@example.com",
      phone: webinfo.phone || "+91 80000 00000",
      phonecall: webinfo.phonecall || "+918000000000",
      address: webinfo.address || "Remote-first • Serving clients worldwide",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="privacy-policy">
      <div className="pp-wrap">
        {/* Header */}
        <header className="privacy-policy-header">
          <p className="pp-eyebrow">Important Notice</p>
          <h1>Website Disclaimer</h1>

          <p>
            This Disclaimer explains the limitations of liability and the nature of
            information provided by {brand.name}. By browsing our website or consuming
            any of our content, you acknowledge and agree to the statements outlined
            below.
          </p>

          <p className="pp-meta">
            <span>Issued by: {brand.name}</span>
            <span>Last updated: {effectiveDate}</span>
          </p>
        </header>

        {/* Content */}
        <div className="privacy-policy-content">

          <section>
            <h2>1. Informational purposes only</h2>
            <p>
              All information on this website is published in good faith and for
              general informational purposes. {brand.name} makes no warranties about
              the completeness, reliability, or accuracy of this information. Content
              may change or be updated without notice.
            </p>
          </section>

          <section>
            <h2>2. No professional advice</h2>
            <p>
              Nothing on this website should be considered professional advice—
              including marketing, technical, legal, financial, strategic, or business
              advice. Any actions you take based on the information on this website
              are strictly at your own risk.
            </p>
          </section>

          <section>
            <h2>3. Results &amp; performance disclaimers</h2>
            <p>
              Any results, case studies, testimonials, or performance metrics shared
              are based on past client experiences and unique conditions. They do not
              guarantee future success. Outcomes depend on market factors, execution,
              industry competitiveness, budgets, audience behavior, and internal
              client processes.
            </p>
          </section>

          <section>
            <h2>4. External links</h2>
            <p>
              Our site may include links to external tools, articles, or platforms.
              While we aim to link to reputable resources, we have no control over
              their content, availability, or updates. {brand.name} is not liable for
              any issues arising from third-party sites.
            </p>
          </section>

          <section>
            <h2>5. Advertising, policies &amp; platforms</h2>
            <p>
              We follow guidelines from major advertising and analytics platforms.
              However, platform rules may change at any time. {brand.name} is not
              responsible for account restrictions, suspensions, or compliance issues
              resulting from client-side configurations, content, or business model.
            </p>
          </section>

          <section>
            <h2>6. Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, {brand.name} disclaims all
              liability for any direct, indirect, incidental, or consequential
              damages arising from the use— or inability to use— the information or
              services described on this website.
            </p>
          </section>

          <section>
            <h2>7. Accuracy, uptime &amp; availability</h2>
            <p>
              Although we strive to provide a smooth and reliable experience,
              we do not guarantee that the website will remain error-free,
              uninterrupted, or fully secure at all times.
            </p>
          </section>

          <section>
            <h2>8. Changes to this Disclaimer</h2>
            <p>
              We may update or revise this Disclaimer from time to time. The
              “Last updated” date indicates the latest version. Your continued use
              of the siteafter such changes constitutes acceptance of the updated
              terms.
            </p>
          </section>

          <section>
            <h2>9. Contact us</h2>
            <p>
              If you have questions or concerns about this Disclaimer, please reach
              out using the details below:
            </p>

            <ul className="pp-contact-list">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
